<section class="flex min-h-[60vh] w-full items-center justify-center px-4">
  <article class="w-full max-w-lg rounded-xl border border-gray-200 bg-white p-8 shadow-sm text-center space-y-6">
    <div class="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mx-auto">
      <span class="material-symbols-outlined text-secondary text-3xl">payments</span>
    </div>

    <div class="space-y-2">
      <h1 class="font-display text-2xl font-bold text-gray-900">Accès expert-comptable</h1>
      <p class="text-sm text-gray-600">
        Pour utiliser Attestio en tant qu'expert-comptable, un paiement unique est requis lors de votre première connexion.
      </p>
    </div>

    @if (checkingStatus()) {
      <p class="text-sm text-gray-500">Vérification du paiement…</p>
    } @else {
      <button
        type="button"
        class="w-full h-11 rounded-lg bg-secondary text-white font-semibold hover:bg-secondary-hover transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
        [disabled]="loading()"
        (click)="startPayment()"
      >
        @if (loading()) {
          Redirection vers le paiement…
        } @else {
          Procéder au paiement
        }
      </button>
      <p class="text-xs text-gray-500">
        Vous serez redirigé vers une page de paiement sécurisée Stripe.
      </p>
    }
  </article>
</section>
